import { RapidModel } from '@/types/rapidModel';
import { defaultConfig } from '@/app/components/shared/viewer/defaultConfig';
import { AssetPreview, StripImage } from '@/app/components/shared/viewer/AssetPreview';
import { usePreviewTabs } from '@/app/components/shared/viewer/hooks';
import { CollapsibleSection } from '@/app/components/shared/viewer/CollapsibleSection';
import { isTooLargeToAutoLoad3DView } from './Viewer';

interface RapidModelPreviewProps {
  rapidModel: RapidModel;
  height: number;
}

const defaultConfigJson = JSON.stringify(defaultConfig);

export function RapidModelPreview({ rapidModel, height }: RapidModelPreviewProps) {
  const isLarge = !rapidModel.meta?.size || isTooLargeToAutoLoad3DView(rapidModel.meta.size);

  const { tab, setTab } = usePreviewTabs(!isLarge ? rapidModel.downloads?.glb : undefined);

  const turntableImages: StripImage[] = rapidModel.thumbnail
    ? Array.from({ length: 12 }).map((_, i) => ({
        src: rapidModel.thumbnail!.turntable,
        title: `preview_${i + 1}`,
        posX: 100 - (100 * (i - 1)) / 11 + i / 200,
      }))
    : [];

  const glbUrl = Array.isArray(rapidModel.downloads?.glb) ? rapidModel.downloads.glb[0] : rapidModel.downloads?.glb;

  return (
    <CollapsibleSection title='Preview'>
      <AssetPreview
        glbUrl={glbUrl}
        images={turntableImages}
        previewConfig={defaultConfigJson}
        tab={tab}
        onTabChanged={setTab}
        previewHeight={height}
        isLarge={isLarge}
      />
    </CollapsibleSection>
  );
}
